import { ImResponse, omsClient, resolve } from '.';

interface GetTaskLogListParams {
  taskId: string;
  offset: number;
  pageSize: number;
}

// 操作日志-操作类型
export type TaskLogOperateType =
  | 'CREATE_TASK'
  | 'UPDATE_TASK'
  | 'DELETE_TASK'
  | 'CREATE_POLICY'
  | 'UPDATE_POLICY'
  | 'DELETE_POLICY'
  | 'MODIFY_POLICY_PRIORITY'
  | 'DELETE_ROUND'
  | 'CREATE_ROUND'
  | 'UPDATE_ROUND';

// 操作日志-变更字段
export type TaskLogChangeField =
  | 'TASK_ENABLE'
  | 'TASK_NAME'
  | 'TASK_FILTER_HAS_CONVERSATION'
  | 'POLICY_FILTER_HAS_CONVERSATION'
  | 'TASK_FILTER_AFTER_SALE_ENABLE'
  | 'POLICY_FILTER_AFTER_SALE_ENABLE'
  | 'TASK_FILTER_AFTER_SALE_CONFIRM_DAYS'
  | 'POLICY_FILTER_AFTER_SALE_CONFIRM_DAYS'
  | 'TASK_FILTER_AFTER_SALE_OUT_OF_ORDER_ITEM'
  | 'POLICY_FILTER_AFTER_SALE_OUT_OF_ORDER_ITEM'
  | 'TASK_PRAISE_TRIGGER_POINT'
  | 'POLICY_PRAISE_TRIGGER_POINT'
  | 'TASK_STORE'
  | 'POLICY_STORE'
  | 'ROUND_EXECUTE_TIME'
  | 'ROUND_EXECUTE_TIME_UNIT'
  | 'POLICY_NAME'
  | 'POLICY_ENABLE'
  | 'POLICY_EXECUTE_CONTEXT'
  | 'POLICY_PRIORITY'
  | 'POLICY_TERM_OF_VALIDITY'
  | 'POLICY_LIMIT_ITEM_TYPE'
  | 'POLICY_LIMIT_ITEM_SPECIFIC_ITEMS'
  | 'POLICY_CANCEL_TRADE_SHIPPING_STATUS'
  | 'POLICY_CANCEL_TRADE_AUTO_CANCEL'
  | 'POLICY_CANCEL_TRADE_AUTO_CANCEL_LIMIT_HOUR'
  | 'POLICY_CANCEL_TRADE_SEND_POINT'
  | 'POLICY_CANCEL_TRADE_EXECUTE_CONTEXT'
  | 'POLICY_AUTO_REVIEW_STARTS'
  | 'POLICY_AUTO_REVIEW_CONTENT'
  | 'POLICY_AUTO_REVIEW_DELAY_DAY'
  | 'POLICY_RETURN_TRADE_RETURN_TYPE'
  | 'POLICY_DELAY_SHIP_DELAY_DAY'
  | 'POLICY_FILTER_RULE_FILTER_WAIT_PROCESS_CONVERSATION'
  | 'POLICY_FILTER_RULE_FILTER_CONSULT'
  | 'POLICY_FILTER_RULE_FILTER_CONSULT_DAYS'
  | 'POLICY_FILTER_RULE_FILTER_CONSULT_AFTER_CREATE_ORDER'
  | 'POLICY_FILTER_RULE_FILTER_NEGATIVE_BUYER';

export interface TaskLog {
  scenarioType: Marketing.AllScenarioType;
  taskId: number;
  taskName: string;
  policyId: number;
  policyName: string;
  roundId: number;
  round: number;
  operatorId: number;
  operatorAccount: string;
  operateType: TaskLogOperateType;
  changeField?: TaskLogChangeField;
  changeDetail?: {
    changeField: TaskLogChangeField;
    before?: boolean | string | number | object;
    after?: boolean | string | number | object;
  };
  createTime: number;
}

// 获取任务操作日志
export const getTaskLogList = (params: GetTaskLogListParams) => {
  return resolve(
    omsClient.get<
      ImResponse<{
        hasNext: boolean;
        nextOffset: number;
        logs?: TaskLog[];
      }>
    >('/log/list', {
      params,
    }),
  );
};
